import { useSelector } from "react-redux";
import { RootState } from "../../state/store";
import GenericCalendar from "../Generic/Calendar";

function Calendar() {
    const User = useSelector((state: RootState) => state.UserInformation);

    return (
        <GenericCalendar
            userId={User.userID}
            canCaptureEvents={true}
        />
    );
}

export default Calendar;
